export const ORDER_DETAIL_MODAL_TITLE = 'How to view order details';
export const ORDER_DETAIL_MODAL_INFO = 'To view more information breakdown of your order, including costs, contract terms and payment frequency, please check your email from us.';
export const ORDER_DETAIL_MODAL_MESSAGE = ' will be in the email subject title.';
